import { createStore } from "vuex";
import axios from "axios";
import { router } from "../router";

import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { AdvertisingId } from "@capacitor-community/advertising-id";

function getInitialShoppingCartItems() {
  const storedItems = localStorage.getItem("shopping_cart_items");

  if (storedItems === null) {
    localStorage.setItem("shopping_cart_items", JSON.stringify([]));
    return [];
  } else {
    return JSON.parse(storedItems)
  }
}

// Create a new store instance.
const store = createStore({
  state: {
    accessToken: localStorage.getItem("access_token") || null,
    refreshToken: localStorage.getItem("refresh_token") || null,
    permission: localStorage.getItem("permission"),
    staff: localStorage.getItem("staff") || false,
    name: localStorage.getItem("name") || null,
    username: localStorage.getItem("username") || null,
    id: localStorage.getItem("id") || null,
    activeElem: localStorage.getItem("activeElem") || null,
    collapseNavBar: localStorage.getItem("collapseNavBar") || false,
    theme: localStorage.getItem("theme") || "customLightTheme",
    router_permissions: localStorage.getItem("router_permissions") || null,
    lastLogin: localStorage.getItem("lastLogin") || null,
    avail_routes: localStorage.getItem("avail_routes") || null,
    device_token: localStorage.getItem("company") || null,
    shopping_cart_items: getInitialShoppingCartItems(),
  },
  mutations: {
    updateLocalStorage(state, { access, refresh, name, id, permission, username, staff, avail_routes, device_token}) {
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
      localStorage.setItem("name", name);
      localStorage.setItem("username", username);
      localStorage.setItem("id", id);
      localStorage.setItem("permission", permission);
      localStorage.setItem("staff", staff);
      localStorage.setItem("avail_routes", avail_routes);

      let currMillis = Date.now()
      localStorage.setItem("lastLogin", currMillis);

      state.accessToken = access;
      state.refreshToken = refresh;
      state.name = name;
      state.username = username;
      state.id = id;
      state.permission = permission;
      state.staff = staff;
      state.lastLogin = currMillis
      state.avail_routes = avail_routes
      state.device_token = device_token;
    },
    updateAccess(state, access) {
      state.accessToken = access;
    },
    updateCollapseNavBar(state, navBar) {
      state.collapseNavBar = navBar;
      localStorage.setItem("collapseNavBar", navBar);
    },
    updateTheme(state, theme) {
      state.theme = theme;
      localStorage.setItem("theme", theme);
    },
    updatePermission(state, permission) {
      state.permission = permission;
      localStorage.setItem("permission", permission);
    },
    updateRouterPermission(state, router_permissions) {
      state.router_permissions = JSON.stringify(router_permissions);
      localStorage.setItem("router_permissions", JSON.stringify(router_permissions));
    },
    updateShoppingCartItems(state, items){
      state.shopping_cart_items = items;
      localStorage.setItem("shopping_cart_items", JSON.stringify(items))
    },
    destroyToken(state) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("name");
      localStorage.removeItem("username");
      localStorage.removeItem("id");
      localStorage.removeItem("activeElem");
      localStorage.removeItem("collapseNavBar");
      localStorage.removeItem("staff");
      localStorage.removeItem("router_permissions");
      localStorage.removeItem("avail_routes");


      axios.defaults.headers.common["Authorization"] = undefined;

      state.accessToken = null;
      state.refreshToken = null;
      state.name = null;
      state.username = null
      state.id = null;
      state.activeElem = null;
      state.collapseNavBar = null;
      state.staff = null;
      state.router_permissions = null
      state.avail_routes = null
      state.device_token = null;

      document.cookie = "sessionid=lzgrs5ax5fof9qdomaeon2p0ysqxoemf" +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    },
    setActiveElem(state, elem) {
      if (!state.activeElem || typeof state.activeElem != "object") {
        state.activeElem = {};
      }

      for (let i in elem) {
        state.activeElem[i] = elem[i];
      }
    },
    updateDeviceToken(state, token) {
      state.device_token = token;
      axios.patch(axios.defaults.baseURL + "user/devicetoken/patch/", {
        push_secret: token,
      }).then((resp) => {

      })
      .catch((e) => {
        console.log(e);
      });
    },
  },
  actions: {
    // run the below action to get a new access token on expiration
    refreshToken(context) {
  return new Promise((resolve, reject) => {
    const refreshToken = this.state.refreshToken;

    const redirectToLogin = (err) => {
      context.commit("destroyToken");
      delete axios.defaults.headers.common["Authorization"];
      router.push("/login");

      setTimeout(() => {
        reject(err);
      }, 200);
    };

    try {
      const base64 = refreshToken.split(".")[1]
        .replace(/-/g, "+")
        .replace(/_/g, "/");

      const payload = JSON.parse(
        atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "="))
      );

      if (
        typeof payload.exp !== "number" ||
        payload.exp * 1000 <= Date.now()
      ) {
        redirectToLogin(new Error("Refresh-Token ist abgelaufen."));
        return;
      }
    } catch (err) {
      redirectToLogin(err);
      return;
    }

    axios
      .post(axios.defaults.baseURL + "token/refresh/", {
        refresh: refreshToken,
      })
      .then((response) => {
        context.commit("updateAccess", response.data.access);
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + response.data.access;

        resolve(response.data.refresh);
      })
      .catch((err) => {
        redirectToLogin(err);
      });
  });

    },
    logoutUser(context) {
      return new Promise((resolve, reject) => {
        axios
          .post(axios.defaults.baseURL + "rest-auth/logout/", {})
          .then(() => {
            context.commit("destroyToken");

            if (Capacitor.isNativePlatform()) {
              router.replace("/login");
            } else {
              router.replace("/");
              setTimeout(() => { window.location.reload(); }, 300);
            }

            resolve();
          })
          .catch((e) => {
            console.log(e);
            context.commit("destroyToken");
            router.replace("/login");
            resolve();
          });
      });
    },
    loginUser(context, credentials) {
      // router.push('/mainPage')
      return new Promise((resolve, reject) => {
        // send the username and password to the backend API:
        axios
          .post(axios.defaults.baseURL + "token/", {
            email: credentials.email,
            password: credentials.password,
          })
          // if successful update local storage:
          .then((response) => {
            context.commit("updateLocalStorage", response.data); // store the access and refresh token in localstorage
            
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + response.data.access;

            // localStorage.setItem("mail", credentials.email);
            // localStorage.setItem("name", credentials.name);
            
            let queryString = window.location.search;
            let urlParams = new URLSearchParams(queryString);
            let next = urlParams.get("next");
            
            // localstorage nach vorhandenem warenkorb etc prüfen und nach login auf checkout weiterleiten
            const checkoutProcess = JSON.parse(localStorage.getItem("in_checkout_process"))

            if(checkoutProcess && !!checkoutProcess){
              router.push("/shop")
            } else {
              if (next && next != "/") {
                router.push(next);
              } else {
                if(response.data["root_route"]){
                  router.push("/" + response.data["root_route"] + "/dashboard")
                  console.error("pushing to root route")
                }
                else{
                  router.push("/main/dashboard")
                }
              }
            }


            if(Capacitor.isNativePlatform()){
              // Request permission for Tracking Ids like Firebase and Google Analytics
              // iOS prompts user
              // Android doesn't prompt user
              AdvertisingId.requestTracking();
              const advertisingId = AdvertisingId.getAdvertisingId();
              
              // Request permission to use push notifications
              // iOS will prompt user and return if they granted permission or not
              // Android will just grant without prompting
              PushNotifications.requestPermissions().then((result) => {
                if (result.receive === "granted") {
                  // Register with Apple / Google to receive push via APNS/FCM
                  // window.alert("berechtigung erteilt")
                  PushNotifications.register();
                }
              });
              
              PushNotifications.addListener("registration", (token) => {
                if (token.value != this.state.device_token) {
                  context.commit("updateDeviceToken", token.value);
                }
                // window.alert("push registrierung erfolgreich")
              });

              PushNotifications.addListener('registrationError',
                (error) => {
                  window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: error }))
                }
              );
            }
              
            resolve(response);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    setActiveElem(context, elem) {
      context.commit("setActiveElem", elem);
    },
    setCollapseNavBar(context, elem) {
      context.commit("updateCollapseNavBar", elem);
    },
    setTheme(context, elem) {
      context.commit("updateTheme", elem);
    },
    setPermission(context, elem) {
      context.commit("updatePermission", elem);
    },
    setRouterPermission(context, elem) {
      context.commit("updateRouterPermission", elem);
    },
    setShoppingCartItems(context, elem) {
      context.commit("updateShoppingCartItems", elem);
    },
  },
});

export { store };
